export const USER_TYPE = {
  SUPER_ADMIN: {
    id: 'super-admin',
    serverAlias: 'admin',
    text: 'Super Admin',
  },
  ADMIN: {
    id: 'admin',
    serverAlias: 'manager',
    text: 'Administrators',
  },
  CONTENT_CREATOR: {
    id: 'content-creator',
    serverAlias: 'teacher',
    text: 'Content Creators',
  },
  LEARNER: {
    id: 'learner',
    serverAlias: 'student',
    text: 'Learners',
  },
};

export const findUserType = (type?: string) =>
  Object.values(USER_TYPE).find(({id}) => id === type) || USER_TYPE.LEARNER;

export const findUserTypeServer = (type?: string) =>
  Object.values(USER_TYPE).find(({serverAlias}) => serverAlias === type) ||
  USER_TYPE.LEARNER;
